import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import http from "../../../BaseUrl"


const openSidebar = createAsyncThunk("/dashboard/openSidebar", async (value) => {
  try {
    return value

  } catch (err) {
    console.log("error", err);
  }
})

const contactAPI = createAsyncThunk("/dashboard/contactAPI", async (value) => {

  try {

    const response = await http.post("/contact/contact", {
      firstName: value.firstName,
      lastName: value.lastName,
      phone: value.phone,
      email: value.email,
      message: value.message
    })
    if (response.status === 200) {
      return response.data
    }

  } catch (err) {
    if (err.status === 400) {
      return err.data.message
    }
  }
})

const checkToken = createAsyncThunk("/dashboard/checkToken", async (value) => {

  return value

})

const getAllCourses = createAsyncThunk("/dashboard/getAllCourses", async ({ is_paid, category, type }) => {
  try {
    const params = new URLSearchParams();

    if (is_paid !== undefined) params.append("is_paid", is_paid);
    if (category && category.length) params.append("category", category.join(","));
    if (type && type.length) params.append("type", type.join(","));

    const response = await http.get(`/courseExtra/getCoursesCondition?${params.toString()}`);

    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    if (err.response && err.response.status === 400) {
      return err.response.data.message;
    }
    throw err;
  }
});

const getAllCoursesLessons = createAsyncThunk("/dashboard/getAllCoursesLessons", async ({ is_paid }) => {
  try {
    const params = new URLSearchParams();

    if (is_paid !== undefined) params.append("is_paid", is_paid);

    const response = await http.get(`/courseExtra/getCoursesCondition?${params.toString()}`);

    if (response.status === 200) {
      return response.data;
    }
    console.log("getAllCoursesLessons response-->", response);

  } catch (err) {
    if (err.response && err.response.status === 400) {
      return err.response.data.message;
    }
    throw err;
  }
});

const getAllStudents = createAsyncThunk("/dashboard/getAllStudents", async () => {

  try {

    const response = await http.get(`/admin/getAllUser`)
    if (response.status === 200) {
      return response.data
    }

  } catch (err) {
    if (err.status === 400) {
      return err.data.message
    }
  }
})

const getDeviceToken_User = createAsyncThunk("/dashboard/admin/getDeviceToken_User", async () => {

  try {

    const response = await http.get(`/admin/getDeviceTokenUser`)
    if (response.status === 200) {
      return response.data
    }

  } catch (err) {
    if (err.status === 400) {
      return err.data.message
    }
  }
})

const getAllEnquiries = createAsyncThunk("/dashboard/getAllEnquiries", async () => {

  try {

    const response = await http.get(`/enquiry/getEnquiryList`)
    if (response.status === 200) {
      return response.data
    }

  } catch (err) {
    if (err.status === 400) {
      return err.data.message
    }
  }
})

const getAllTransactions = createAsyncThunk("/dashboard/getAllTransactions", async () => {

  try {

    const response = await http.get(`/admin/getAllTransactions`)
    if (response.status === 200) {
      return response.data
    }

  } catch (err) {
    if (err.status === 400) {
      return err.data.message
    }
  }
})

const createCourses = createAsyncThunk("/dashboard/createCourses", async (FormData) => {

  try {

    const response = await http.post("/courseExtra/createCourse", FormData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the correct content type for FormData
      },

    })
    console.log("response", response);

    if (response.status === 200) {
      return response.data
    }
  }
  catch (err) {
    return err.response.data
  }
})

const updateCourse = createAsyncThunk("/dashboard/updateCourse", async ({ courseId, FormData }) => {

  try {

    const response = await http.put(`/courseExtra/updateCourse/${courseId}`, FormData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the correct content type for FormData
      },

    })

    if (response.status === 200) {
      return response.data
    }
  }
  catch (err) {
    return err.response.data
  }
})

const createEnquiryResponse = createAsyncThunk(
  "adminDashboard/createEnquiryResponse",
  async ({ enquiryId, response }, { rejectWithValue }) => {
    try {
      const res = await http.put(`/enquiry/submitResponse/${enquiryId}`, {
        response,
      });
      console.log("response enquiry", response);

      if (res.status === 200) {
        return { enquiryId, response, message: res.data?.message || "Response submitted" };
      } else {
        return rejectWithValue("Unexpected response status");
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error submitting response");
    }
  }
);

const startLiveSession = createAsyncThunk(
  "/dashboard/startLiveSession",
  async ({ title, description, youtube_link }, { rejectWithValue }) => {
    try {
      const response = await http.post("/live/start", {
        title,
        description,
        youtube_link
      });

      if (response.status === 201) {
        return response.data;
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error starting live session");
    }
  }
);

const endLiveSession = createAsyncThunk(
  "/dashboard/endLiveSession",
  async ({ sessionId }, { rejectWithValue }) => {
    try {
      const response = await http.put(`/live/end/${sessionId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error ending live session");
    }
  }
);

const getActiveLiveSessions = createAsyncThunk(
  "/dashboard/getActiveLiveSessions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await http.get("/live/active");

      if (response.status === 200) {
        console.log("response", response)
        return response.data;

      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error fetching active live sessions");
    }
  }
);

const getAllLiveSessions = createAsyncThunk(
  "/dashboard/getAllLiveSessions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await http.get("/live/all");

      if (response.status === 200) {
        console.log("response", response)
        return response.data;

      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error fetching active live sessions");
    }
  }
);

const selectedCourse = createAsyncThunk("/adminDashboard/selectedCourse", async (value) => {
  return value
})

const selectedTransaction = createAsyncThunk("/adminDashboard/selectedTransaction", async (value) => {

  return value
})

const popUpDashboard = createAsyncThunk("/auth/popUpDashboard", async (value) => {

  return value
})

const openCreateCourseDialog = createAsyncThunk("/auth/openCreateCourseDialog", async (value) => {
  return value
})

const openshowTransactionDialog = createAsyncThunk("/auth/openshowTransactionDialog", async (value) => {
  return value
})

const openEditCourseDialog = createAsyncThunk("/auth/openEditCourseDialog", async (value) => {
  return value
})

const openCreateNewCourseDialog = createAsyncThunk("/auth/openCreateNewCourseDialog", async (value) => {
  return value
})

const openAddStudentDialog = createAsyncThunk("/auth/openAddStudentDialog", async (value) => {
  return value
})

const openViewEnquiryDialog = createAsyncThunk("/auth/openViewEnquiryDialog", async (value) => {
  return value
})

const selectedEnquiries = createAsyncThunk("/auth/selectedEnquiries", async (value) => {
  return value
})

const openBulkActionDialog = createAsyncThunk("/auth/openBulkActionDialog", async (value) => {
  return value
})

const openBulkCoursesDialog = createAsyncThunk("/auth/openBulkCoursesDialog", async (value) => {
  return value
})

const deleteCourse = createAsyncThunk(
  "adminDashboard/deleteCourse",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/courseExtra/deleteCourse/${id}`);

      if (response.status === 200) {
        return id; // Return the ID of the deleted staff to update state
      }

    } catch (err) {
      console.error("API Error:", err.response);
      return rejectWithValue(err.response?.data || "Error deleting Course");
    }
  }
);

const deleteFolderFromCourse = createAsyncThunk(
  "adminDashboard/deleteFolderFromCourse",
  async ({ folderId }, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/course/deleteFolderById/${folderId}`);

      if (response.status === 200) {
        return { folderId, message: response.data.message || "Folder deleted" };
      } else {
        return rejectWithValue("Unexpected response status");
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error deleting folder");
    }
  }
);

const deleteFileFromCourse = createAsyncThunk(
  "adminDashboard/deleteFileFromCourse",
  async ({ fileId }, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/course/deleteFileById/${fileId}`);

      if (response.status === 200) {
        return { fileId, message: response.data.message || "File deleted successfully" };
      } else {
        return rejectWithValue("Unexpected response status");
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error deleting folder");
    }
  }
);

const getAllTransactionsById = createAsyncThunk(
  "adminDashboard/getAllTransactionsById",
  async ({ id }, { rejectWithValue }) => {

    try {
      const response = await http.get(`/admin/getAllTransactionsById/${id}`);
      if (response.status === 200) {
        return (
          response.data.data
        );
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error deleting folder");
    }
  }
);

const blockStudent = createAsyncThunk(
  "adminDashboard/blockStudent",
  async ({ userId, blocked }, { rejectWithValue }) => {

    try {
      const response = await http.put(`/admin/blockStudent/${userId}`, {
        blocked, // 🔄 Send boolean value
      });
      if (response.status == 200) {
        return response.data; // Return updated user data
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error blocking student");
    }
  }
);

const hideCourses = createAsyncThunk(
  "adminDashboard/hideCourses",
  async ({ userId, courses = [], lessons = [], subjects = [], contents = [] }, { rejectWithValue }) => {
    try {
      const response = await http.put(`/admin/hideCourses/${userId}`, {
        courses,
        lessons,
        subjects,
        contents
      });

      if (response.status === 200) {
        return response.data; // Return updated user data
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error hiding content");
    }
  }
);

const paidUnpaidStudent = createAsyncThunk(
  "adminDashboard/paidUnpaidStudent",
  async ({ userId, paid }, { rejectWithValue }) => {
    try {
      const response = await http.put(`/admin/paidUnpaidStudent/${userId}`, {
        paid, // 🔄 Send boolean value
      });

      console.log("response", response);

      if (response.status === 200) {
        return response.data; // Return updated user data
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error updating paid status");
    }
  }
);

const initialState = {

  dashShow: false,
  showCreateCourseDialog: false,
  openshowTransactionDialog: false,
  showCreateNewCourseDialog: false,
  showAddStudentDialog: false,
  showEditCourseDialog: false,
  openEnquiryDialog: false,
  bulkActionLoader: false,
  showBulkActionDialog: false,
  selectedBulkStudents: [],
  selectedBulkAction: null,
  showBulkCoursesDialog: null,
  coursesData: [],
  createEnquiryResponse: [],
  getStudents: [],
  getEnquiries: [],
  getTransactions: [],
  deleteCourses: [],
  deleteFolderFromCourses: [],
  deleteFileFromCourses: [],
  getTransactionsById: [],
  blockStudents: [],
  hideCourses: [],
  loader: true,
  check: false,
  createCourses: [],
  updateCourses: [],
  getTokenUser: [],
  showDashPopup: false,
  selectedCourseFolder: null,
  selectedChapter: null,
  selectedTransaction: null,
  selectedStudentEnquiry: null,
  allCoursesLessons: [],
  liveSessions: [],
  activeLiveSessions: [],
  allLiveSessions: []

}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers: (builder) => {
    builder
      // open Create CourseDialog
      .addCase(openCreateCourseDialog.pending, (state, action) => { state.loader = true })
      .addCase(openCreateCourseDialog.fulfilled, (state, action) => {
        state.showCreateCourseDialog = action.payload
        state.loader = false

      })
      .addCase(openCreateCourseDialog.rejected, (state, action) => { state.loader = true })

      // open View Enquiry Dialog
      .addCase(openViewEnquiryDialog.pending, (state, action) => { state.loader = true })
      .addCase(openViewEnquiryDialog.fulfilled, (state, action) => {
        state.openEnquiryDialog = action.payload
        state.loader = false

      })
      .addCase(openViewEnquiryDialog.rejected, (state, action) => { state.loader = true })

      // open Create Transaction Dialog
      .addCase(openshowTransactionDialog.pending, (state, action) => { state.loader = true })
      .addCase(openshowTransactionDialog.fulfilled, (state, action) => {
        state.openshowTransactionDialog = action.payload
        state.loader = false

      })
      .addCase(openshowTransactionDialog.rejected, (state, action) => { state.loader = true })

      // open Edit Course Dialog
      .addCase(openEditCourseDialog.pending, (state, action) => { state.loader = true })
      .addCase(openEditCourseDialog.fulfilled, (state, action) => {
        state.showEditCourseDialog = action.payload
        state.loader = false

      })
      .addCase(openEditCourseDialog.rejected, (state, action) => { state.loader = true })

      // Delte Course by ID
      .addCase(deleteCourse.pending, (state, action) => { state.loader = true })
      .addCase(deleteCourse.fulfilled, (state, action) => {

        // state.deleteCourses = action.payload
        state.deleteCourses = state.deleteCourses.filter(course => course.course_id !== action.payload);
        state.loader = false

      })
      .addCase(deleteCourse.rejected, (state, action) => { state.loader = false })

      // Delete Folder from Course
      .addCase(deleteFolderFromCourse.pending, (state) => {
        state.loader = true;
      })
      .addCase(deleteFolderFromCourse.fulfilled, (state, action) => {
        state.deleteFolderFromCourses = action.payload;
        state.loader = false;
      })
      .addCase(deleteFolderFromCourse.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // Delete File from Course
      .addCase(deleteFileFromCourse.pending, (state) => {
        state.loader = true;
      })
      .addCase(deleteFileFromCourse.fulfilled, (state, action) => {
        state.deleteFileFromCourses = action.payload;
        state.loader = false;
      })
      .addCase(deleteFileFromCourse.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // get All Transactions By Id
      .addCase(getAllTransactionsById.pending, (state) => {
        state.loader = true;
      })
      .addCase(getAllTransactionsById.fulfilled, (state, action) => {
        state.getTransactionsById = action.payload;
        state.loader = false;
      })
      .addCase(getAllTransactionsById.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // Block Student
      .addCase(blockStudent.pending, (state) => {
        state.loader = false;
      })
      .addCase(blockStudent.fulfilled, (state, action) => {
        state.loader = false;
        state.blockStudents = action.payload;

      })
      .addCase(blockStudent.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // hide course
      .addCase(hideCourses.pending, (state) => {
        state.loader = false;
      })
      .addCase(hideCourses.fulfilled, (state, action) => {
        state.loader = false;
        state.hideCourses = action.payload;

      })
      .addCase(hideCourses.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // Paid/Unpaid Student
      .addCase(paidUnpaidStudent.pending, (state) => {
        state.loader = false;
      })
      .addCase(paidUnpaidStudent.fulfilled, (state, action) => {
        state.loader = false;
        const updatedStudent = action.payload.data; // Assuming payload contains { data: user }

      })
      .addCase(paidUnpaidStudent.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // open Create New CourseDialog
      .addCase(openCreateNewCourseDialog.pending, (state, action) => { state.loader = true })
      .addCase(openCreateNewCourseDialog.fulfilled, (state, action) => {
        state.showCreateNewCourseDialog = action.payload
        state.loader = false

      })
      .addCase(openCreateNewCourseDialog.rejected, (state, action) => { state.loader = true })

      // open Create New CourseDialog
      .addCase(openAddStudentDialog.pending, (state, action) => { state.loader = true })
      .addCase(openAddStudentDialog.fulfilled, (state, action) => {
        state.showAddStudentDialog = action.payload
        state.loader = false

      })
      .addCase(openAddStudentDialog.rejected, (state, action) => { state.loader = true })

      // open Bulk Action Dialog
      .addCase(openBulkActionDialog.pending, (state, action) => { state.bulkActionLoader = true })
      .addCase(openBulkActionDialog.fulfilled, (state, action) => {
        state.showBulkActionDialog = action.payload.open;
        state.selectedBulkStudents = action.payload.users || [];
        state.selectedBulkAction = action.payload.action;
        state.bulkActionLoader = false
      })
      .addCase(openBulkActionDialog.rejected, (state, action) => { state.bulkActionLoader = false })

      // open Bulk Action Dialog
      .addCase(openBulkCoursesDialog.pending, (state, action) => { state.bulkActionLoader = true })
      .addCase(openBulkCoursesDialog.fulfilled, (state, action) => {
        state.showBulkCoursesDialog = action.payload;
        state.bulkActionLoader = false
      })
      .addCase(openBulkCoursesDialog.rejected, (state, action) => { state.bulkActionLoader = false })

      // open contact
      .addCase(openSidebar.pending, (state, action) => { state.loader = true })
      .addCase(openSidebar.fulfilled, (state, action) => {
        state.dashShow = action.payload
        state.loader = false
      })
      .addCase(openSidebar.rejected, (state, action) => { state.loader = false })

      //  contact Api
      .addCase(contactAPI.pending, (state, action) => { state.loader = true })
      .addCase(contactAPI.fulfilled, (state, action) => {
        state.dashShow = false
        state.loader = false
        // state.contactAPI=action.payload

      })
      .addCase(contactAPI.rejected, (state, action) => { state.loader = false })

      // updated token quickly
      .addCase(checkToken.pending, (state, action) => { state.loader = true })
      .addCase(checkToken.fulfilled, (state, action) => {
        state.check = action.payload
        state.loader = false
      })
      .addCase(checkToken.rejected, (state, action) => { state.loader = false })

      // create Course
      .addCase(createCourses.pending, (state, action) => { state.loader = true })
      .addCase(createCourses.fulfilled, (state, action) => {
        state.createCourses = action.payload
        state.loader = false
      })
      .addCase(createCourses.rejected, (state, action) => { state.loader = false })

      // create Enquiry Response
      .addCase(createEnquiryResponse.pending, (state, action) => { state.loader = true })
      .addCase(createEnquiryResponse.fulfilled, (state, action) => {
        state.createEnquiryResponse = action.payload
        state.loader = false
      })
      .addCase(createEnquiryResponse.rejected, (state, action) => { state.loader = false })

      // Update Course
      .addCase(updateCourse.pending, (state, action) => { state.loader = true })
      .addCase(updateCourse.fulfilled, (state, action) => {
        console.log("action.payload", action.payload);

        state.updateCourses = action.payload
        state.loader = false
      })
      .addCase(updateCourse.rejected, (state, action) => { state.loader = false })

      // get All Courses
      .addCase(getAllCourses.pending, (state, action) => { state.loader = true })
      .addCase(getAllCourses.fulfilled, (state, action) => {
        state.coursesData = action.payload.data
        state.loader = false
        state.showDashPopup = true

      })
      .addCase(getAllCourses.rejected, (state, action) => {
        state.loader = false
        state.coursesData = null
      })

      // get All Courses Lessons
      .addCase(getAllCoursesLessons.pending, (state, action) => { state.loader = true })
      .addCase(getAllCoursesLessons.fulfilled, (state, action) => {
        state.allCoursesLessons = action.payload.data
        state.loader = false
        state.showDashPopup = true

      })
      .addCase(getAllCoursesLessons.rejected, (state, action) => {
        state.loader = false
        state.coursesData = null
      })

      // get All Students
      .addCase(getAllStudents.pending, (state, action) => { state.loader = true })
      .addCase(getAllStudents.fulfilled, (state, action) => {
        state.getStudents = action.payload.data
        state.loader = false

      })
      .addCase(getAllStudents.rejected, (state, action) => { state.loader = false })

      // get device Token Users
      .addCase(getDeviceToken_User.pending, (state, action) => { state.loader = true })
      .addCase(getDeviceToken_User.fulfilled, (state, action) => {
        state.getTokenUser = action.payload.data
        state.loader = false

      })
      .addCase(getDeviceToken_User.rejected, (state, action) => { state.loader = false })

      // get All Enquiries
      .addCase(getAllEnquiries.pending, (state, action) => { state.loader = true })
      .addCase(getAllEnquiries.fulfilled, (state, action) => {
        state.getEnquiries = action.payload.enquiries
        state.loader = false

      })
      .addCase(getAllEnquiries.rejected, (state, action) => { state.loader = false })

      // get All Transactions
      .addCase(getAllTransactions.pending, (state, action) => { state.loader = true })
      .addCase(getAllTransactions.fulfilled, (state, action) => {
        state.getTransactions = action.payload.data
        state.loader = false

      })
      .addCase(getAllTransactions.rejected, (state, action) => { state.loader = false })

      // Selected Data 
      .addCase(selectedCourse.pending, (state, action) => { state.loader = true })
      .addCase(selectedCourse.fulfilled, (state, action) => {
        state.selectedChapter = action.payload
        state.selectedCourseFolder = action.payload
        state.loader = false
      })
      .addCase(selectedCourse.rejected, (state, action) => { state.loader = false })

      // Selected Transaction Data 
      .addCase(selectedTransaction.pending, (state, action) => { state.loader = true })
      .addCase(selectedTransaction.fulfilled, (state, action) => {

        state.selectedTransaction = action.payload
        state.loader = false
      })
      .addCase(selectedTransaction.rejected, (state, action) => { state.loader = false })

      // Selected Enquiry Data 
      .addCase(selectedEnquiries.pending, (state, action) => { state.loader = true })
      .addCase(selectedEnquiries.fulfilled, (state, action) => {
        state.selectedStudentEnquiry = action.payload
        state.loader = false
      })
      .addCase(selectedEnquiries.rejected, (state, action) => { state.loader = false })

      //message popup
      .addCase(popUpDashboard.pending, (state, action) => { state.loader = true })
      .addCase(popUpDashboard.fulfilled, (state, action) => {

        state.showpopUpDashboard = action.payload
        state.loader = false

      })
      .addCase(popUpDashboard.rejected, (state, action) => { state.loader = true })

      // Start Live Session
      .addCase(startLiveSession.pending, (state) => {
        state.loader = true;
      })
      .addCase(startLiveSession.fulfilled, (state, action) => {
        state.liveSessions.push(action.payload.session);
        state.loader = false;
      })
      .addCase(startLiveSession.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // End Live Session
      .addCase(endLiveSession.pending, (state) => {
        state.loader = true;
      })
      .addCase(endLiveSession.fulfilled, (state, action) => {
        const endedSession = action.payload.session;
        state.liveSessions = state.liveSessions.map(session =>
          session._id === endedSession._id ? endedSession : session
        );
        state.activeLiveSessions = state.activeLiveSessions.filter(
          session => session._id !== endedSession._id
        );
        state.loader = false;
      })
      .addCase(endLiveSession.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // Get Active Live Sessions
      .addCase(getActiveLiveSessions.pending, (state) => {
        state.loader = true;
      })
      .addCase(getActiveLiveSessions.fulfilled, (state, action) => {
        state.activeLiveSessions = action.payload.sessions;
        state.loader = false;
      })
      .addCase(getActiveLiveSessions.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

      // Get ALl Live Session
      .addCase(getAllLiveSessions.pending, (state) => {
        state.loader = true;
      })
      .addCase(getAllLiveSessions.fulfilled, (state, action) => {
        state.allLiveSessions = action.payload.sessions;
        state.loader = false;
      })
      .addCase(getAllLiveSessions.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })

  }
})
export {
  openSidebar, contactAPI, blockStudent, hideCourses, openViewEnquiryDialog, paidUnpaidStudent, selectedEnquiries, getAllCoursesLessons, createEnquiryResponse, openAddStudentDialog, openBulkActionDialog, openBulkCoursesDialog, deleteFileFromCourse, getAllTransactions, getAllTransactionsById, openCreateCourseDialog, selectedTransaction, openshowTransactionDialog, getAllEnquiries, deleteCourse, deleteFolderFromCourse, openEditCourseDialog, popUpDashboard, getAllCourses, checkToken, getAllStudents, createCourses, selectedCourse, updateCourse, openCreateNewCourseDialog, startLiveSession,
  endLiveSession,
  getActiveLiveSessions, getAllLiveSessions, getDeviceToken_User
}


export default dashboardSlice.reducer